/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="BaseSelectorView.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.IndicatorJumpSelectorView = ns.BaseSelectorView.extend({
    name: "Indicator Jump Selector",
    el: "#indicator-jump-selector",
    templateSelector: "#indicator-jump-selector-template",
    propertyName: "indicatorIdJump",

    events: {
      "change select": "onChangeUpdateModel"
    },

    onChangeUpdateModel: function() {
      this.scrollToIndicator();
    },

    /**
     * Initializes the model with the default values for this selector.
     * In this case, the default for the indicator jump is no indicator at all.
     */
    initializeModel: function() {
      this.model.set(this.propertyName, null, { silent: true });
    },

    scrollToIndicator: function() {
      var indicatorId, scrollTop;

      indicatorId = this.$("select").val();
      scrollTop = $(
        ".profile-indicator-container[data-id=" + indicatorId + "]"
      ).offset().top;
      $("body, html").animate({ scrollTop: scrollTop }, 0);
      // The text of the select should always read as the disabled options ("Jump to...").
      // This is by design.
      this.$("option:disabled").prop("selected", true);
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      return null;
    },

    updateDOM: function() {
      var indicators;

      indicators = this.model.get("indicatorIds");

      if (indicators.length >= 5) {
        this.$el.show();
        return;
      }

      this.$el.hide();
    }
  });
})(jQuery, _);
